export * from './slim-nav-update-state';
